import React from 'react';
import { Icon } from '@weezevent/nacre';
import TicketCard from '../../../detail/components/ticket-card/ticketCard';
import { PreviewEmpty } from '../../../../sessions/components/previewEmpty';
import Order from './Order';
import Rates from './Rates';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../context/useAppContext';

export default function Summary({ form, setForm, timer }) {
    const { t } = useTranslation();
    const [{ event }] = useAppContext();
    const { use_sessions, use_inventories } = form;

    const title = React.useMemo(() => {
        if (use_inventories) {
            return t('ticket.seats.previewEmptyTitle');
        }

        if (use_sessions) {
            return t('ticket.sessions.list.previewEmptyTitle');
        }

        return t('attendees.addAttendees.previewEmptyTitle');
    }, [form, t, event]);

    if (form.inventories?.length || form.sessions?.length || form.selected_rates.length) {
        return (
            <TicketCard>
                <Order form={form} setForm={setForm} />
                {form.selected_rates.length > 0 && <Rates form={form} timer={timer} />}
            </TicketCard>
        );
    }
    return <PreviewEmpty title={title} icon={<Icon name="cart" size="huge" />} />;
}
